import Swiper from "swiper";
import { Navigation, Parallax, Lazy } from "swiper";

Swiper.use([Navigation, Parallax, Lazy]);

export default function () {
  const sections = document.querySelectorAll('.simple-slider');
  sections.forEach((section) => {
    new Swiper(section, {
      speed: 800,
      parallax: true,
      watchSlidesProgress: true,
      preloadImages: false,
      lazy: {
        loadPrevNext: true,
        loadOnTransitionStart: true,
      },
      navigation: {
        prevEl: section.querySelector('.swiper-button-prev'),
        nextEl: section.querySelector('.swiper-button-next'),
      },
    });
  });

}